enum Actions {
  // action types
  ADD_BODY_CLASSNAME = 'addBodyClassName',
  REMOVE_BODY_CLASSNAME = 'removeBodyClassName',
  ADD_BODY_ATTRIBUTE = 'addBodyAttribute',
  REMOVE_BODY_ATTRIBUTE = 'removeBodyAttribute',
  ADD_CLASSNAME = 'addClassName',
  VERIFY_AUTH = 'verifyAuth',
  LOGIN = 'login',
  LOGOUT = 'logout',
  REGISTER = 'register',
  UPDATE_USER = 'updateUser',
  FORGOT_PASSWORD = 'forgotPassword',
  SET_BREADCRUMB_ACTION = 'setBreadcrumbAction',
  SET_PHOTO = 'UPDATE_PHOTO',
  UPDATE_PASSWORD = 'UPDATE_PASSWORD',
  UPDATE_EMAIL = 'UPDATE_EMAIL',
  CHECK_SCHEDULES = 'CHECK_SCHEDULES',
}

enum Mutations {
  // mutation types
  SET_CLASSNAME_BY_POSITION = 'appendBreadcrumb',
  PURGE_AUTH = 'logOut',
  SET_AUTH = 'setAuth',
  SET_USER = 'setUser',
  SET_STUDENT = 'setStudent',
  SET_PASSWORD = 'setPassword',
  SET_ERROR = 'setError',
  SET_SY = 'setSY',
  SET_SERVER_CONFIG = 'setServerConfig',
  SET_TRIMESTER = 'setTrimester',
  SET_BREADCRUMB_MUTATION = 'setBreadcrumbMutation',
  SET_LAYOUT_CONFIG = 'setLayoutConfig',
  RESET_LAYOUT_CONFIG = 'resetLayoutConfig',
  OVERRIDE_LAYOUT_CONFIG = 'overrideLayoutConfig',
  OVERRIDE_PAGE_LAYOUT_CONFIG = 'overridePageLayoutConfig',
  SET_PHOTO = 'SET_PHOTO',
  SET_UPDATED_PROFILE_ALERT = 'SET_UPDATED_PROFILE_ALERT',
  SET_BUILDING_DB = 'SET_BUILDING_DB',
  SWITCH_TO_TEACHER = 'SWITCH_TO_TEACHER',
  SWITCH_TO_ADVISOR = 'SWITCH_TO_ADVISOR',
  SET_TEACHER_SWITCHER_VALUE = 'SET_TEACHER_SWITCHER_VALUE',
}

export { Actions, Mutations }
